<template>
    <div>
        <b-row role="alert">
            <b-col>
                <div class="sr-only hidden" v-if="isLoading">Processed Affirmations Loading, Please Wait...</div>
            </b-col>
        </b-row>
        <b-table hover small responsive show-empty class="sr-caption"
            aria-live="polite"
            :id="slug"
            :fields="fields"
            :items="items"
            primary-key="id"
            :busy="isLoading"
            label-sort-asc=""
            label-sort-desc=""
            caption="Processed affirmations table.  To sort the data in this table by a specific column,
                go to the appropriate column header cell and use enter to sort the data ascending.
                Use enter again to sort descending.">
            <template v-slot:cell(actions)="row">
                <b-button size="sm" @click="launchAffirm(row.item)"
                    variant="primary"
                    class="mr-1"
                    v-if="row.item.isActiveOrPending && row.item.affirmationStatus === 'DENIED'"
                >
                change affirmation decision
                </b-button>
                <b-button size="sm" @click="showTerminateModal(row.item)"
                          variant="primary"
                          class="mr-1"
                          v-if="row.item.isActiveOrPending && row.item.affirmationStatus === 'AFFIRMED'"
                >
                    Terminate
                </b-button>
                <FileAttachmentSupervisor v-bind:id="'fas'+row.item.applicationId"
                                          v-if="row.item.isActiveOrPending && row.item.licenseSubcategory === 'TEMPORARY' && row.item.affirmationStatus !== 'DENIED' && row.item.affirmationStatus !=='WITHDRAW'"
                                          :appId="row.item.applicationId"
                                          :hasSupervisoryPlan="row.item.hasSupervisoryPlan"
                                          v-on:attachment-added="attachmentAdded"
                />
            </template>

            <template v-slot:empty="scope">
                <p>No processed affirmations found for this work queue.</p>
            </template>

            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"
                           label="Loading, Please Wait" aria-label="Loading, Please Wait"></b-spinner>
                <strong>Loading, Please Wait...</strong>
            </div>  
        </b-table>
        <b-modal id="terminate-modal" hide-header hide-footer>
            <div v-if="selected">
                <h2 >Terminate {{ssLabel}}ship</h2>
                <hr/>
                <form ref="form" @submit.prevent="terminate">
                    You are about to terminate your {{ssLabel}} affirmation for the {{selected.formattedCategory}}
                    application from user {{selected.fullName}}.  Please provide the reason for termination.
                    <BaseParagraphInput v-model="reason"
                                   :v="$v.reason"
                                   slug="reason"
                                   label="Termination Reason"
                                   setId="terminate-modal-id"/>
                    <p class="mt-2">Press Confirm to terminate or Cancel to return to your dashboard.</p>
                    <div>
                        <b-button @click="closeTerminateModal" style="margin-right:15px;" variant="secondary">Cancel</b-button>
                        <b-button type="submit" variant="primary">Confirm</b-button>
                    </div>
                </form>
            </div>
        </b-modal>
    </div>
</template>

<script>
import moment from 'moment'
import { required } from 'vuelidate/lib/validators'
import axios from 'axios'
import FileAttachmentSupervisor from "@/components/templates/input/FileAttachmentSupervisor";

export default {
    components: {
        FileAttachmentSupervisor
    },
    props: {
        items: Array,
        slug: [String],
        isLoading: Boolean,
    },
    data: () => ({
        fields: [
            {key: 'receivedDate', sortable: true, label: 'Date Received'},
            {key: 'formattedType', sortable: true, label: 'Type'},
            {key: 'formattedCategory', sortable: true, label: 'License Category'},
            {key: 'fullName', sortable: true, label: 'Licensee Name'},
            {key: 'affirmationStatus', sortable: true, label: 'Affirmed/Denied'},
            {key: 'isActive', sortable: true, label: 'License Active'},
            {key: 'hasSupervisoryPlan', sortable: true, label: 'Has Supervisory Plan?'},
            {key: 'actions', label: 'Actions'}
        ],
        selected: null,
        reason: null
    }),

    methods: {
        launchAffirm(item) {
            this.$router.push({ name: 'affirm', params: { id: item.applicationId  } })
        },

        showTerminateModal(item) {
            this.$bvModal.show('terminate-modal')
            this.selected = item
        },

        closeTerminateModal() {
            this.selected = null
            this.reason = null
            this.$bvModal.hide('terminate-modal')
        },

        terminate(action) {
            const payload = {
                applicationId: this.selected.applicationId,
                licenseNbr: this.selected.licenseNbr,
                reason: this.reason
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/supervisor/terminate`, payload)
                .then(response => {
                    this.showRootToast("Termination Successful", "Your "+this.ssLabel+"ship for this application has been terminated.", "success")
                    this.$emit('on-update')
                    this.closeTerminateModal()
                }).catch(error => {
                if (error.response.status === 406) {
                    this.showRootToast("Not Terminated",
                        this.ssLabel+"ship can only be terminated for Pending or Active licenses.", "danger")
                } else {
                    this.showRootToast("Error", "An error has occurred while processing your request", "danger")
                }
                this.closeTerminateModal()
            })
        },
        showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
                title: title,
                toaster: 'b-toaster-top-center',
                solid: true,
                variant: type,
                appendToast: true,
                noAutoHide:true
            })
            this.toastFocus()
        },
        toastFocus() {
            setTimeout(() => {
                let elem = document.getElementsByClassName("toast")
                elem = elem[elem.length-1]
                elem.focus()
            }, 100)
        },
        attachmentAdded(value){
            this.$emit('attachment-added',value);
        }
    },
    computed: {
        ssLabel() {
            if (this.selected.licenseSubCategory == 'GUEST') {
                return "Sponsor"
            } else {
                return "Supervisor"
            }
        },
    },
    validations() {
        return {
            reason: {
                required
            },
            form: [ 'reason' ]
        }
    },
}
</script>
<style>
.paCol { width: 15%; }
</style>